module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "offset-y": "",
      "left": "",
      "close-on-content-click": false
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticClass: "full-width",
          class: _vm.buttonClass,
          attrs: {
            "rounded": "",
            "depressed": ""
          },
          on: {
            "click": _vm.initialiseDropdown
          }
        }, on), [_vm._v(_vm._s(_vm.label))])]
      }
    }]),
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_vm._v(" "), _c('v-list', [(!_vm.existingOnly) ? _c('div', {
    staticClass: "display-flex ma-3"
  }, [_c('v-text-field', {
    ref: "group",
    staticStyle: {
      "flex-grow": "1"
    },
    attrs: {
      "label": "Name of Group",
      "hide-details": ""
    },
    model: {
      value: (_vm.groupName),
      callback: function($$v) {
        _vm.groupName = $$v
      },
      expression: "groupName"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-top": "14px"
    },
    attrs: {
      "depressed": "",
      "rounded": ""
    },
    on: {
      "click": _vm.newGroup
    }
  }, [_vm._v("Go")])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.groups), function(group, groupIndex) {
    return _c('v-list-item', {
      key: groupIndex,
      on: {
        "click": function($event) {
          return _vm.select(group)
        }
      }
    }, [_c('v-chip', {
      staticStyle: {
        "margin": "0px 5px 0 -3px",
        "width": "44px",
        "text-align": "center"
      },
      attrs: {
        "dark": "",
        "small": "",
        "color": group.colour || '#ccc'
      }
    }, [_vm._v(_vm._s(group.members || '0'))]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(_vm._f("space")(group._id)))])], 1)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af404dbe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/GroupDropdown.vue
// module id = 2644
// module chunks = 1